import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-warning no-margin" }
const _hoisted_2 = { class: "row no-margin" }
const _hoisted_3 = { class: "text-weight-regular" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "text-info text-bold" }
const _hoisted_7 = { class: "text-info text-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "row text-h5" }, "-", -1)
const _hoisted_11 = { class: "text-h5" }

import { date, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import { LABELS } from "src/env/labels"
import { DATE_TIME_FULL_MASK } from "src/util/constants/configurations"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogSystemNotification',
  props: {
  startTime: {
    type: [String, Date],
    required: true,
  },

  endTime: {
    type: [String, Date],
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogOK } = useDialogPluginComponent()
const startTimeFormatted = computed(() => date.formatDate(props.startTime, DATE_TIME_FULL_MASK))
const endTimeFormatted = computed(() => date.formatDate(props.endTime, DATE_TIME_FULL_MASK))

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    persistent: "",
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "bg-orange-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("sfxDialogSystem.title")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("h5", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogSystem.text1")) + "  ", 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("sfxDialogSystem.between")) + ":", 1)
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(startTimeFormatted.value) + " ", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("sfxDialogSystem.and")) + "  ", 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(endTimeFormatted.value), 1)
              ]),
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("sfxDialogSystem.text2")), 1),
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(LABELS).SUPPORT), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                class: "full-width",
                label: _ctx.$t('sfxButtons.btn_noted'),
                onClick: _unref(onDialogOK)
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})